module.exports = __webpack_public_path__ + "img/container-bg.7351242e.png";